class SlideoutModal extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.modalTrigger = document.querySelector(this.dataset.trigger);
    
    if(!this.modalTrigger) return;
    
    this.modalCloseTrigger = this.querySelector(`#${this.modalTrigger.dataset.modal}__popup-close-btn`);
    this.footerEle = this.querySelector(".modal-slideout-footer");
    this._init();
  }

  _init() {
    // open the modal
    this.modalTrigger.addEventListener('click', e => {
      e.stopPropagation();
      this.open();
    });

    // close the modal
    if(!this.modalCloseTrigger) return;
    this.modalCloseTrigger.addEventListener('click', e => {
      e.preventDefault();
      this.close();
    });

    // close the modal, when clicked outside of the main content of the slideout
    this.el.addEventListener("click", e => {
      if (!e.target.closest('.modal-slideout__content')) {
        this.close();
      }
    });
  }

  open() {
    this.el.classList.remove('hidden');
    document.querySelector('body').classList.add('overflow-hidden');

    this.el.dispatchEvent(new CustomEvent('modal:opened', {
      bubbles: true,
      cancelable: true
    }));
  }

  close() {
    const { valid, feedback } = this.validate();

    if(valid) {
      this.el.classList.add('hidden');
      document.querySelector('body').classList.remove('overflow-hidden');

      this.el.dispatchEvent(new CustomEvent('modal:closed', {
        bubbles: true,
        cancelable: true
      }));
    }
    const feedbackEle = this.querySelector('.modal-slideout-feedback');
    if(feedbackEle) {
      feedbackEle.innerHTML = feedback;
    }
  }

  isClosed() {
    return this.classList.contains('hidden');
  }

  validate() {
    return {
      valid: true,
      feedback: '', 
    };
  }
}

customElements.define("slideout-modal", SlideoutModal);